import { RiServerFill } from "react-icons/ri";
import {
  COSTUM,
  DATE,
  SELECT,
} from "../../Component/Modals/ModalComponents/ModalInputTypes";
import { HISOBOT } from "../../Component/Sidebar/PageTypes";
import PrintBtn from "./components/PrintBtn";
import Refresh from "./components/Refresh";
const MijozAktsverka = {
  title: "Мижоз Акт сверка",
  path: "/hisobot/mijoz-aktsverka",
  icon: <RiServerFill></RiServerFill>,
  type: HISOBOT,
  allData: [{ value: "mijoz_id", prop: "mijozlar", get: "fio" }],
  hisobotActions: [
    {
      grid: "1fr 1fr 3fr 1fr",
      inputs: [
        {
          label: "Сана 1",
          name: "sana1",
          type: DATE,
        },
        {
          label: "Сана 2",
          name: "sana2",
          type: DATE,
          secondDate: true,
        },
        {
          label: "Мижозлар",
          name: "mijoz_id",
          type: SELECT,
          required: true,
          allData: {
            type: "mijozlar",
            key: "Id",
            text: "fio",
          },
        },
        {
          type: COSTUM,
          component: (
            <div
              style={{ display: "flex", gridGap: "10px", alignItems: "center" }}
            >
              <Refresh text="Янгилаш"></Refresh>
              <PrintBtn></PrintBtn>
            </div>
          ),
        },
      ],
    },
  ],
};
export default MijozAktsverka;
